var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[(_vm.templatesIsLoad)?_c('trumbowyg',_vm._g(_vm._b({ref:"editor",attrs:{"id":"myEditorId","config":_vm.config()}},'trumbowyg',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }